module.exports = __webpack_public_path__ + "/hashedassets-launcher/v3/warning.ade0ca0c6c014d8cf9c0b3d294f019b5.svg";